exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".badge[data-v-76ca17af]:hover {\n  cursor: pointer;\n}\n.is-invalid .form-control[data-v-76ca17af] {\n  border-left: 2px solid red !important;\n}", ""]);

// exports
